export enum NotificationMessageTypeIconsEnum {
  error = 'error_outline',
  info = 'info',
  ok = 'check_circle',
  warn = 'report-problem',
}
